var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ud-html-cell",style:(("height:" + (_vm.cell.height) + "px")),domProps:{"innerHTML":_vm._s(_vm.htmlContent)}})}
var staticRenderFns = []

export { render, staticRenderFns }